//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../../../components/ImageUploader";

export default {
    name: "shangmen-view",
    components: {ImageUploader},
    data() {
        return {
            shangMenPopup: false,
            showShangMenTime: false,
            shangMenInputDto: {
                id: 0,
                image: {
                    addAttrIds: [],
                    delAttrIds: [],
                }
            },
            shangMenRecords: [],
            saving: false,
            id: 0,
            currentDate: ''
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        onSaveShangMenRecord() {
            if (this.shangMenInputDto.image.addAttrIds.length === 0) {
                this.$toast('请上传照片')
                return;
            }
            this.saving = true;
            this.shangMenInputDto.workOrderId = this.workOrderInfo.id;
            abp.ajax.post('/api/services/app/WorkOrder/MSaveShangMenRecord', this.shangMenInputDto).then(res => {
                this.shangMenPopup = false
                this.$emit('handleSuccess');
            }).finally(() => {
                this.saving = false;
            })
        },
        show(d) {
            this.shangMenInputDto = {}
            this.shangMenInputDto = d;
            this.shangMenInputDto.image = {
                addAttrIds: [],
                delAttrIds: [],
            };
            this.shangMenPopup = true;
        },
        // onShangMenTimeConfirm(val) {
        //     this.shangMenInputDto.operationTime = this.formatDate(val);
        //     this.showShangMenTime = false;
        // },
        // formatDate(date) {
        //     var m = date.getMonth() + 1;
        //     if (m < 10) {
        //         m = '0' + m;
        //     }
        //     var d = date.getDate();
        //     if (d < 10) {
        //         d = '0' + d;
        //     }
        //     return `${date.getFullYear()}-${m}-${d}`;
        // },
    },
    created() {

    }
}
